import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, delay } from 'rxjs/operators';
import { ApiService } from './api.service';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {
  razorpayBaseUrl: string = 'https://api.razorpay.com/v1/';

  constructor(
    private apiService: ApiService,
    private httpClient: HttpClient,
  ) { }

  private formatErrors(error: any): Observable<never> {
    // Customize error formatting as needed
    return throwError(() => new Error(error));
  }

  getPacksByGroup(): Observable<any> {
    return this.apiService.get('subscription/getpacksbygroup');
  }

  getPaymentModes(): Observable<any> {
    return this.apiService.post('payment_modes');
  }

  getOrderId(checkSum, queryParams): Observable<any> {
    return this.httpClient.get(environment.payment_base_url + 'platform8/charge/' + checkSum + '?' + queryParams);
  }

  preBilling(urlEncodedParams: any): Observable<any> {
    return this.httpClient.get(environment.payment_base_url + 'jcocg/SDKCharge/PG/NEXG_SDK?' + urlEncodedParams);
  }
  postBilling(urlEncodedParams: any): Observable<any> {
    return this.httpClient.get(environment.payment_base_url + 'webhook/sdk/razorpay?' + urlEncodedParams);
  }

  createOrder(body: any = {}): Observable<any> {
    // return this.apiService.post(this.razorpayBaseUrl + 'orders', body);
    return this.httpClient.post(this.razorpayBaseUrl + 'orders', body).pipe(catchError(this.formatErrors));
  }

  postGatewayData(request: string, x_verify: any): Observable<any> {
    let request_params:any = {request};
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-VERIFY': x_verify });
    return this.httpClient.post('https://api-preprod.phonepe.com/apis/pg-sandbox/pg/v1/pay', request_params,{headers}).pipe(
      catchError(this.formatErrors)
    );
  }

  getPurchaseUrl(urlEncodedParams): Observable<any> {
    return this.apiService.get(`purchaseurl?${urlEncodedParams}`)
  }

  getCouponList(body): Observable<any> {
    return this.apiService.post('couponverification/couponlist', body);
  }

  applyCoupon(queryParams): Observable<any> {
    return this.apiService.post('couponverification?' + queryParams);
  }

  redeemCoupon(body): Observable<any> {
    return this.apiService.post('couponverification/couponRedemption', body);
  }

  checkRecurringCard(cardNumber: any): Observable<any> {
    const key_id = 'rzp_test_s7T2Ru2JZrU8fi';
    const key_secret = 'Hv606QRh8I9R3hkUdHzF5Xbf';
  
    const basicAuth = btoa(`${key_id}:${key_secret}`); // Encode to base64
  
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Basic ${basicAuth}`
    });

    return this.httpClient.get(environment.payment_base_url + 'card/status/' + cardNumber);
  
    // return this.httpClient
    //   .post(this.razorpayBaseUrl + 'iifc/' + cardNumber, { headers })
    //   .pipe(catchError(this.formatErrors));

    const simulatedResponse = {
      "iin": cardNumber,
      "entity": "iin",
      "network": "Visa",
      "type": "prepaid",
      "sub_type": "consumer",
      "card_iin": "411140",
      "issuer_code": "unknown",
      "issuer_name": "unknown",
      "international": true,
      "tokenised": true,
      "emi": {
        "available": false
      },
      "recurring": {
        "available": cardNumber == 411111
      },
      "authentication_types": [
        {
          "type": "3ds"
        }
      ]
    }

    return of(simulatedResponse).pipe(delay(500));
  }
  
}
